import React, { createContext, useContext } from 'react';

export const TestContext = createContext();

export const useTest = () => {
    return useContext(TestContext);
};